import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const ChevronRight: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M13.1724 12.0007L8.92977 7.75804C8.53924 7.36751 8.53924 6.73435 8.92977 6.34382C9.32029 5.9533 9.95346 5.9533 10.344 6.34382L15.1707 11.1706C15.6292 11.6291 15.6292 12.3723 15.1707 12.8308L10.344 17.6575C9.95345 18.048 9.3203 18.048 8.92978 17.6575C8.53925 17.267 8.53925 16.6338 8.92978 16.2433L13.1724 12.0007Z"
      fill={color}
    />
  </svg>
)
